import * as React from 'react';
export const vancitySvg = React.forwardRef(function vancitySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E6192C',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M14.41 25.72c.07.07.27.23.57.23h2.03c.3 0 .5-.16.57-.23 6.89-5.39 7.56-16.54 7.5-19.67h-4.8C20.35 8 19.88 17.4 16 22c-3.88-4.6-4.35-14-4.3-15.95H6.92c-.07 3.13.61 14.28 7.5 19.67z',
      }),
    ),
  );
});
vancitySvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var vancity = {
  category: 'brand',
  colorable: false,
  name: 'vancity',
  svg: vancitySvg,
};
